var map = {
	"./symbol_0.png": 58983,
	"./symbol_1.png": 6494,
	"./symbol_10.png": 62460,
	"./symbol_11.png": 75525,
	"./symbol_12.png": 3726,
	"./symbol_2.png": 92245,
	"./symbol_3.png": 56332,
	"./symbol_4.png": 32579,
	"./symbol_5.png": 68474,
	"./symbol_6.png": 89585,
	"./symbol_7.png": 79368,
	"./symbol_8.png": 9215,
	"./symbol_9.png": 12278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29570;